import { EcommerceCreativeName, EcommerceElement, Context } from '@pegasus/tracker';
import { Campaign } from '@shared/types/mylounge/campaign';
import { useLeavingSoon } from '../../leavingSoon';
import { useNewDeals } from '../../newDeals';
import { TrackingParams } from '../../hooks';

import { CAMPAIGN_COUNT_CONSTANTS, LEAVING_SOON_VIEW_HREF, NEW_DEALS_VIEW_HREF } from '../helpers';

export interface CarouselData {
    campaigns: Campaign[] | [];
    translationsPath: string;
    carouselHref: string;
    emphasisLevel: 'high' | 'default';
    trackingParams: TrackingParams;
}

export interface CarouselsData {
    newDeals: CarouselData | null;
    leavingSoon: CarouselData | null;
}

export const useCampaignsCarouselData = (): CarouselsData => {
    const newDealsData = useNewDeals();
    const leavingSoonData = useLeavingSoon();

    const canNewDealsCarouselBeShown =
        newDealsData &&
        newDealsData.isNewDealFeatureEnabled &&
        newDealsData.campaignsForNewDeal.length ===
            CAMPAIGN_COUNT_CONSTANTS.EIGHT_CAMPAIGNS_CAROUSEL;

    const canLeavingSoonCarouselBeShown =
        leavingSoonData &&
        leavingSoonData.isLeavingSoonComponent &&
        leavingSoonData.campaignsForLeavingSoonCarousel.length ===
            CAMPAIGN_COUNT_CONSTANTS.EIGHT_CAMPAIGNS_CAROUSEL;

    return {
        newDeals: canNewDealsCarouselBeShown
            ? {
                  campaigns: newDealsData.campaignsForNewDeal,
                  translationsPath: 'newDealsToday',
                  carouselHref: NEW_DEALS_VIEW_HREF,
                  emphasisLevel: 'high',
                  trackingParams: {
                      element: 'deals_today_carousel' as EcommerceElement,
                      creativeName: 'deals_today_carousel' as EcommerceCreativeName,
                      itemListName: 'deals_today_carousel' as Context,
                  },
              }
            : null,
        leavingSoon: canLeavingSoonCarouselBeShown
            ? {
                  campaigns: leavingSoonData.campaignsForLeavingSoonCarousel,
                  translationsPath: 'leavingSoon',
                  carouselHref: LEAVING_SOON_VIEW_HREF,
                  emphasisLevel: 'default',
                  trackingParams: {
                      element: 'ending_soon_carousel' as EcommerceElement,
                      creativeName: 'ending_soon_carousel' as EcommerceCreativeName,
                      itemListName: 'ending_soon_carousel' as Context,
                  },
              }
            : null,
    };
};
